import CookieNames from "src/constants/cookie-names";
import CookieHelper from "./cookie-helper";

export default class KioskHelper {
    public static isKiosk(): boolean {
        return !!CookieHelper.getCookieValue(CookieNames.KIOSK_DEVICE);
    }
}
